const log = (...args) => console.log(...args);
const logWarn = (...args) => console.warn(...args);
const logError = (...args) => console.error(...args);

export { log, logWarn, logError };
